import { render, staticRenderFns } from "./safetyActionTargetDetailPlan.vue?vue&type=template&id=34054714"
import script from "./safetyActionTargetDetailPlan.vue?vue&type=script&lang=js"
export * from "./safetyActionTargetDetailPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34054714')) {
      api.createRecord('34054714', component.options)
    } else {
      api.reload('34054714', component.options)
    }
    module.hot.accept("./safetyActionTargetDetailPlan.vue?vue&type=template&id=34054714", function () {
      api.rerender('34054714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sat/safetyActionTargetDetailPlan.vue"
export default component.exports